export const CURRENT_STATE_SORT_ADDRESS = 'address';
export const CURRENT_STATE_SORT_BACKUP_BATTERY = 'backupBattery';
export const CURRENT_STATE_SORT_DATE = 'date';
export const CURRENT_STATE_SORT_HOUR_METER = 'hourMeter';
export const CURRENT_STATE_SORT_IDENTIFIER = 'identifier';
export const CURRENT_STATE_SORT_LABEL = 'label';
export const CURRENT_STATE_SORT_LICENSE_PLATE = 'licensePlate';
export const CURRENT_STATE_SORT_ODOMETER = 'odometer';
export const CURRENT_STATE_SORT_POWERSOURCE = 'powersource';
export const CURRENT_STATE_SORT_SATELLITES = 'satellites';
export const CURRENT_STATE_SORT_SIGNAL = 'signal';
export const CURRENT_STATE_SORT_SPEED = 'speed';
export const CURRENT_STATE_SORT_STATUS = 'status';
export const CURRENT_STATE_SORT_TYPE = 'type';

export const CURRENT_STATE_SORT_OPTIONS = [
  {
    id: CURRENT_STATE_SORT_LICENSE_PLATE,
    label: 'Placa',
  },
  {
    id: CURRENT_STATE_SORT_IDENTIFIER,
    label: 'Identificador',
  },
  {
    id: CURRENT_STATE_SORT_LABEL,
    label: 'Etiqueta',
  },
  {
    id: CURRENT_STATE_SORT_DATE,
    label: 'Fecha',
  },
  {
    id: CURRENT_STATE_SORT_ODOMETER,
    label: 'Odómetro',
  },
  {
    id: CURRENT_STATE_SORT_HOUR_METER,
    label: 'Horómetro',
  },
  {
    id: CURRENT_STATE_SORT_STATUS,
    label: 'Estatus',
  },
  {
    id: CURRENT_STATE_SORT_SPEED,
    label: 'Velocidad',
  },
  {
    id: CURRENT_STATE_SORT_BACKUP_BATTERY,
    label: 'Batería de reserva',
  },
  {
    id: CURRENT_STATE_SORT_POWERSOURCE,
    label: 'Alimentación',
  },
  {
    id: CURRENT_STATE_SORT_SATELLITES,
    label: 'Satélites',
  },
  {
    id: CURRENT_STATE_SORT_SIGNAL,
    label: 'Señal GSM',
  },
  {
    id: CURRENT_STATE_SORT_TYPE,
    label: 'Tipo',
  },
  {
    id: CURRENT_STATE_SORT_ADDRESS,
    label: 'Dirección',
  },
];
